import { BORDERLESS_BORDER } from '../../../../shared/boxes/borderStyles';

/**
 * Schéma de style de la Frise (cf. shared/theme/styleSchema) : ce qu'un style
 * du thème pose, et les valeurs de départ du bloc.
 */
export const TIMELINE_STYLE_SCHEMA = {
  layout: { default: 'vertical-left' },
  // Bleu de repli du webviewer : le picker montre la couleur réellement
  // rendue dès la création (un défaut vide s'y affichait en blanc).
  color: { default: '#228be6' },
  bulletSize: { default: '1.5rem' },
  border: { default: () => ({ ...BORDERLESS_BORDER }) },
  backgroundColor: { default: '' },
  /** Clé de l'échelle d'ombre (`shared/boxes/shadowStyles`). */
  shadow: { default: 'none' },
  alignHorizontal: { style: 'theme', seed: true },
  alignVertical: { style: 'theme', seed: true },
  textStyles: { style: 'theme' },
};
